import React, {FC, useState} from 'react'

import {observer} from 'mobx-react-lite'

import Input from 'components/elements/fields/Input'
import {parseNumber, getStringValue} from 'src/utils'

import {IInputProps} from '../Input/Input'

interface IMobxTextInputProps extends IInputProps {
	name: string
	isFormatText?: boolean
	isNumber?: boolean
	/** Determines whether we should store the oldValue and restore it if thу value of the input did not changed */
	shouldHandleOldValue?: boolean
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	store: any
}

const MobxTextInput: FC<IMobxTextInputProps> = ({
	name,
	store,
	shouldHandleOldValue,
	isNumber,
	isFormatText,
	variant,
	...props
}) => {
	const [oldValue, setOldValue] = useState('')
	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		let newValue: string | number = e.target.value
		if (shouldHandleOldValue) setOldValue('')
		if (isNumber) {
			if (isNaN(Number(parseNumber(e.target.value))) || Number(parseNumber(e.target.value)) < 0) {
				return
			} else {
				newValue = parseNumber(e.target.value, true)
			}
		}
		store[name] = newValue
	}

	const onBlur = (e: React.FocusEvent<HTMLInputElement, Element>) => {
		if (isFormatText) {
			const newValue = e.target.value || oldValue

			store[name] = getStringValue(newValue)

			if (shouldHandleOldValue) {
				if (oldValue !== newValue) {
					props.onBlur && props.onBlur(e)
				}
				setOldValue('')
			} else {
				props.onBlur && props.onBlur(e)
			}
			return
		}

		props.onBlur && props.onBlur(e)
	}

	const onFocus = (e: React.FocusEvent<HTMLInputElement>) => {
		if (shouldHandleOldValue) setOldValue(store[name])
		props.onFocus && props.onFocus(e)
	}

	return (
		<Input
			value={oldValue ? '' : `${store[name]}` || ''}
			name={name}
			onChange={onChange}
			disabled={props.disabled || props.readOnly}
			{...props}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholder={oldValue || props.placeholder}
			variant={variant}
		/>
	)
}

MobxTextInput.displayName = 'MobxTextInput'

export default observer(MobxTextInput)
